import * as types from '../actions/actionsTypes'
import initialState from './initialState'

export default function homePageReducer(state = initialState.homePageData, action) {
  if (action.type === types.LOAD_HOME_PAGE_DATA_SUCCESS) {
    return action.homePageData;
  }
  return state;
}
